import React from 'react'
import { graphql } from 'gatsby'
import { Jumbotron } from 'reactstrap'
import { Helmet } from 'react-helmet'

import Toc from '../components/toc'
import Layout from '../components/layout'
import BreadcrumbNav from '../components/breadcrumb-nav'
import {
  flattenFileNode,
  matterNameFromMatter,
  classeNameFromClasse,
  classeWikidataURIFromClasse,
} from '../helpers'

export default ({ data, location }) => {
  const programme = data.markdownRemark

  const description = `programme officiel de ${matterNameFromMatter(
    programme.fields.matter
  )} en ${classeNameFromClasse(programme.fields.classe)}`

  return (
    <Layout location={location} data={data}>
      <Helmet
        title={`${description}`}
        meta={[
          {
            name: `description`,
            description: `${description} proposé par lyceum, un site open-source pour le lycée`,
          },
          {
            name: `keywords`,
            content: `programme, officiel, BO, ${
              programme.fields.matter
            }, ${classeNameFromClasse(programme.fields.classe)},`,
          },
        ]}
      >
        <script type="application/ld+json">{`
         {"@context": "http://schema.org/",
          "@type": "Programme",
          "name": "Programme officiel de ${
            programme.fields.matter
          }, ${classeNameFromClasse(programme.fields.classe)}",
          "description": "${description}",
          "learningResourceType": [
            "programme"    ],
          "provider": {
            "@type": "schema:EducationalOrganization",
            "name": "lyceum.fr"
          },
          "audience": {
            "@type": "EducationalAudience",
            "educationalRole": "teacher"
          },
          "educationalAlignment": {
            "@type": "AlignmentObject",
            "alignmentType": "educationalLevel",
            "educationalFramework": "French Grade Levels",
            "targetName": "${classeNameFromClasse(programme.classe)}",
            "@id": "${classeWikidataURIFromClasse(programme.classe)}"
          },
          "url": "${location.href}"
        }
    `}</script>
      </Helmet>
      <BreadcrumbNav node={flattenFileNode(programme)} />
      <Jumbotron>
        <h1 className="display-1">{`Programme de ${matterNameFromMatter(
          programme.fields.matter
        )} en ${classeNameFromClasse(programme.fields.classe)}`}</h1>
        <Toc tableOfContents={programme.tableOfContents} />
      </Jumbotron>
      <div dangerouslySetInnerHTML={{ __html: programme.html }} />
    </Layout>
  )
}

export const query = graphql`
  query MDProgrammeQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      tableOfContents
      fields {
        classe
        matter
        slug
      }
    }
  }
`
